export default [
  {
    key: "increasement",
    sortable: true,
    sortField: "createdAt",
    label: "#",
    thClass: "w-50px",
  },
  {
    key: "title",
    sortable: false,
    label: "field.title",
    stickyColumn: true,
    variant: "light",
  },
  {
    key: "timeRange",
    label: "field.workingHour",
  },
  {
    key: "timezone",
    label: "field.timezone",
  },
  {
    key: "actions",
    label: "general.action",
  },
];
